let _ = t => t,
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7,
  _t8,
  _t9,
  _t10;
import styled from 'styled-components';
import { Link as RouterLink } from 'react-router-dom';
import { styledIf, rotate, fontSize, fontWeights } from '@ovpn-ui/styles';
import { opacityBlur } from '../../Navigation.utils';
import { sidebarAnimation, menuHeight, subMenuHeight } from '../Sidebar.constants';
export const Wrapper = styled.li(_t || (_t = _`
    margin: 8px 0;

    color: ${0};
    font-weight: ${0};
    font-size: ${0};
`), t => t.theme.text, fontWeights.medium, fontSize.default);
const LinkBase = styled(RouterLink)(_t2 || (_t2 = _`
    display: flex;
    align-items: center;

    box-sizing: border-box;

    padding: 8px;

    color: ${0};
    white-space: nowrap;
    text-decoration: none;

    border: 1px solid transparent;
    border-radius: 4px;
    cursor: pointer;

    user-select: none;

    &:hover {
        background: ${0};
    }

    &:focus {
        background: ${0};
        box-shadow: 0px 0px 0px 4px rgba(59, 145, 241, 0.45);
    }

    &:active {
        background: ${0};

        &:hover {
            background: ${0};
        }
    }
`), t => t.theme.text, t => t.theme.itemHoverColor, t => t.theme.itemHoverColor, ({
  theme
}) => theme.itemActiveColor, ({
  theme
}) => theme.itemActiveHoverColor);
export const Link = styled(LinkBase)(_t3 || (_t3 = _`
    display: flex;
    justify-content: space-between;

    width: 100%;
    height: ${0}px;

    font-size: ${0};

    ${0}

    /* Show flyout menu when hovering over a menu item */
    &:hover {
        & > .sidebar-flyout {
            visibility: visible;
            opacity: 1;

            transition: opacity 65ms ease-in;
            transition-delay: 255ms;
        }
    }

    /* Apply styles to parent item when $active is true */
    ${0}

    /* Styles for when $disableExpand is true */
    ${0}
`), menuHeight, fontSize.default, props => props.$expanded && !props.$active && `background: ${props.theme.itemHoverColor};`, props => props.$active && `background: ${props.theme.itemActiveColor};`, styledIf('$disableExpand')(_t4 || (_t4 = _`
        cursor: ${0};
        background: none;

        &:hover {
            background: ${0};
        }
    `), t => t.$open ? 'default' : 'pointer', t => t.$open ? 'none' : t.theme.itemHoverColor));
export const SubLinkWrapper = styled.div(_t5 || (_t5 = _`
    ${0}
`), opacityBlur());
export const SubLink = styled(LinkBase)(_t6 || (_t6 = _`
    display: flex;
    justify-content: space-between;
    height: ${0}px;
    margin: 8px 4px 4px;
    padding-left: 45px;

    font-size: ${0};

    ${0}
`), subMenuHeight, fontSize.default, props => props.$active && `background: ${props.theme.itemActiveColor};`);
export const Title = styled.span(_t7 || (_t7 = _`
    flex-grow: 1;

    padding-left: 8px;

    overflow-x: hidden;

    white-space: nowrap;

    ${0}
`), opacityBlur());
export const Decorator = styled.div(_t8 || (_t8 = _`
    display: flex;
    align-items: center;
    justify-content: flex-end;

    overflow: hidden;
`));
export const Icon = styled.div(_t9 || (_t9 = _`
    display: flex;
    flex-shrink: 0;
    justify-content: center;
    min-width: 20px;
    max-width: 100%;
    overflow: hidden;

    color: ${0};

    svg:not(.icon-tabler) path {
        fill: ${0};
    }

    transition: margin-left ${0};

    will-change: margin-left;
`), t => t.theme.text, t => t.theme.text, sidebarAnimation);
export const ChevronWrapper = styled.div(_t10 || (_t10 = _`
    margin-left: 8px;

    color: ${0};

    ${0};

    ${0}

    transition: transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, opacity ${0};

    ${0}
`), t => t.theme.text, rotate(0, 180), opacityBlur(), sidebarAnimation, props => !props.$open && `cursor:default;`);